var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppDevelopmentSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 468.89 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b1b4c4;}.cls-2{fill:#e4e7f2;}.cls-3,.cls-6{fill:#d6d8e5;}.cls-4{fill:#fff;}.cls-5{opacity:0.5;fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15);}.cls-6{opacity:0.4;}.cls-7{fill:#2b303f;}.cls-8{fill:#c3c6d1;}.cls-9{fill:#e9eaf2;}.cls-10{fill:#2f55d4;}.cls-11{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_7);}.cls-12{fill:none;stroke:#cccedd;stroke-miterlimit:10;stroke-width:1.06px;}.cls-13{fill:#ffcea9;}.cls-14{fill:#38226d;}.cls-15{fill:#9c73ff;}.cls-16{fill:#f4f4f4;}.cls-17{fill:#3a2c6d;}.cls-18{fill:#bfbfbf;}.cls-19{fill:#e5e5e5;}.cls-20{fill:#ededed;}.cls-21{fill:#211b49;}.cls-22{fill:#2e245b;}.cls-23{fill:#a298e2;}.cls-24{fill:#c33afc;}.cls-25{fill:#f4ce2c;}.cls-26{fill:#ff8657;}.cls-27{fill:#4d3bff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15",
    x1: -216.9,
    y1: 2341.61,
    x2: -216.9,
    y2: 2174.34,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 509.95, -2294.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_7",
    x1: 285.59,
    y1: 433.22,
    x2: 285.59,
    y2: 478.42,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 94.31, -401.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9eaf2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9eaf2",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "app_development_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laptop"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450,384.63,199.93,240.23c-3.51-2-6.35-7.46-6.35-12.13V34.63c0-4.68,2.84-6.83,6.35-4.8L450,174.23c3.51,2,6.35,7.46,6.35,12.13V379.83C456.39,384.51,453.55,386.66,450,384.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "451.33 386.63 454.1 385.03 452.9 376.82 451.33 386.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.13,31l2.73-1.58,3.92,2.24s-4.18.63-4.28.61S193.13,31,193.13,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.75,386,197.64,241.56c-3.51-2-6.36-7.46-6.36-12.14V36c0-4.68,2.85-6.83,6.36-4.8l250.11,144.4c3.51,2,6.35,7.46,6.35,12.14V381.16C454.1,385.83,451.26,388,447.75,386Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M447.31,386.21,197.2,241.81c-3.51-2-6.36-7.46-6.36-12.14V36.2c0-4.67,2.85-6.82,6.36-4.8L447.31,175.8c3.5,2,6.35,7.46,6.35,12.14V381.41C453.66,386.09,450.81,388.24,447.31,386.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M450.22,374.44,194,226.53,194.15,37c0-1.94,1.36-2.73,3-1.76l250.11,144.4a6.72,6.72,0,0,1,3,5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M450.14,374.45,194,226.54,194.08,37c0-1.94,1.36-2.73,3-1.76l250.11,144.4a6.73,6.73,0,0,1,3,5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.67,498.63,8.56,354.23c-3.51-2-3.07-5.56,1-7.9l167.55-96.74c4-2.33,10.18-2.59,13.68-.56l250.12,144.4c3.5,2,3.06,5.56-1,7.9L272.35,498.07C268.3,500.4,262.17,500.66,258.67,498.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.13,495.35,14,351c-3.51-2-3.07-5.56,1-7.9l167.55-96.73c4-2.34,10.18-2.6,13.69-.57l250.11,144.4c3.51,2,3.07,5.56-1,7.9L277.82,494.79C273.77,497.12,267.64,497.38,264.13,495.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.65 347.69 11.65 342.97 16.95 345.19 11.65 347.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "448.72 393.68 448.72 389.07 444.8 390.42 447.4 394.24 448.72 393.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M264.13,491.38,14,347c-3.51-2-3.07-5.56,1-7.9l167.55-96.74c4-2.34,10.18-2.59,13.69-.56l250.11,144.4c3.51,2,3.07,5.56-1,7.9L277.82,490.81C273.77,493.15,267.64,493.41,264.13,491.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264.13,490.77,14,346.37c-3.51-2-3.07-5.57,1-7.9l167.55-96.74c4-2.34,10.18-2.59,13.69-.57L446.35,385.57c3.51,2,3.07,5.56-1,7.9L277.82,490.2C273.77,492.54,267.64,492.79,264.13,490.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.91,274.36l-11.64-6.72c-1-.55-.83-1.51.26-2.14l11.12-6.42a4.11,4.11,0,0,1,3.7-.15L193,265.65c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,177.91,274.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M194.4,283.88l-11.65-6.73c-.95-.54-.83-1.5.27-2.14l11.11-6.41a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c1,.55.83,1.51-.26,2.14l-11.12,6.41A4.08,4.08,0,0,1,194.4,283.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M211.07,293.51l-11.64-6.73c-1-.55-.83-1.51.26-2.14l11.12-6.41a4.08,4.08,0,0,1,3.7-.16l11.65,6.73c1,.54.83,1.5-.27,2.14l-11.11,6.41A4.17,4.17,0,0,1,211.07,293.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M227.37,302.91l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.65,6.72c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,227.37,302.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M243.86,312.43l-11.65-6.72c-1-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.11,4.11,0,0,1,243.86,312.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M260.34,322l-11.64-6.72c-.95-.55-.84-1.51.26-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.65,6.72c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,260.34,322Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M276.83,331.47l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c.95.55.83,1.51-.26,2.14l-11.12,6.41A4.08,4.08,0,0,1,276.83,331.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M293.31,341l-11.64-6.73c-.95-.55-.83-1.5.26-2.14l11.12-6.41a4.08,4.08,0,0,1,3.7-.16l11.65,6.73c1,.55.83,1.5-.27,2.14L297,340.83A4.1,4.1,0,0,1,293.31,341Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M309.8,350.5l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.41a4.1,4.1,0,0,1,3.71-.16l11.64,6.73c.95.54.83,1.5-.26,2.14l-11.11,6.41A4.13,4.13,0,0,1,309.8,350.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M326.28,360l-11.64-6.72c-.95-.55-.83-1.51.26-2.14L326,344.74a4.11,4.11,0,0,1,3.7-.15l11.65,6.72c.95.55.83,1.51-.27,2.14L330,359.87A4.13,4.13,0,0,1,326.28,360Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M342.77,369.54l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.65,6.72c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,342.77,369.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M359.26,379.06l-11.65-6.72c-.95-.55-.83-1.51.27-2.14L359,363.78a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c1,.55.83,1.51-.27,2.14L363,378.91A4.11,4.11,0,0,1,359.26,379.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M375.74,388.58l-11.64-6.73c-1-.55-.84-1.5.26-2.14l11.11-6.41a4.13,4.13,0,0,1,3.71-.16l11.65,6.73c.95.55.83,1.5-.27,2.14l-11.11,6.41A4.1,4.1,0,0,1,375.74,388.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M400.17,402.68l-19.59-11.31c-.95-.55-.83-1.51.27-2.14L392,382.82a4.1,4.1,0,0,1,3.71-.16L415.25,394c.95.55.83,1.51-.26,2.14l-11.12,6.42A4.11,4.11,0,0,1,400.17,402.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M186.39,297.7,174.74,291c-1-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15L201.47,289c.95.55.83,1.51-.26,2.14l-11.12,6.42A4.11,4.11,0,0,1,186.39,297.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M202.9,307.24l-11.64-6.72c-.95-.55-.83-1.51.26-2.14L202.64,292a4.11,4.11,0,0,1,3.7-.15L218,298.53c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,202.9,307.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M219.42,316.77l-11.65-6.72c-1-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c.95.55.83,1.51-.26,2.14l-11.12,6.42A4.11,4.11,0,0,1,219.42,316.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M235.93,326.31l-11.65-6.73c-.95-.54-.83-1.5.27-2.14L235.66,311a4.13,4.13,0,0,1,3.71-.16L251,317.6c.95.55.83,1.5-.27,2.14l-11.11,6.41A4.1,4.1,0,0,1,235.93,326.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M252.31,335.77,240.67,329c-.95-.55-.83-1.5.26-2.14l11.12-6.41a4.08,4.08,0,0,1,3.7-.16l11.65,6.73c1,.54.83,1.5-.27,2.14L256,335.61A4.13,4.13,0,0,1,252.31,335.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M268.83,345.3l-11.65-6.72c-.95-.55-.83-1.51.27-2.14L268.56,330a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c.95.55.83,1.51-.26,2.14l-11.12,6.42A4.11,4.11,0,0,1,268.83,345.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M285.34,354.83l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.41a4.1,4.1,0,0,1,3.71-.16l11.65,6.73c.95.54.83,1.5-.27,2.14l-11.11,6.41A4.13,4.13,0,0,1,285.34,354.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M301.85,364.37l-11.64-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.11,4.11,0,0,1,3.7-.15l11.65,6.72c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,301.85,364.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M318.37,373.9l-11.65-6.72c-1-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c.95.55.84,1.51-.26,2.14l-11.11,6.42A4.13,4.13,0,0,1,318.37,373.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M334.88,383.44l-11.64-6.73c-.95-.54-.83-1.5.26-2.14l11.12-6.41a4.14,4.14,0,0,1,3.7-.16L350,374.73c.95.55.83,1.51-.27,2.14l-11.11,6.41A4.1,4.1,0,0,1,334.88,383.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M351.4,393l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c.95.55.83,1.51-.26,2.14l-11.12,6.42A4.11,4.11,0,0,1,351.4,393Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M367.91,402.51l-11.64-6.73c-.95-.55-.84-1.5.26-2.14l11.11-6.41a4.13,4.13,0,0,1,3.71-.16L383,393.8c.95.55.83,1.5-.27,2.14l-11.11,6.41A4.1,4.1,0,0,1,367.91,402.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M169.87,288.17l-19.58-11.31c-.95-.55-.83-1.5.26-2.14l11.12-6.41a4.08,4.08,0,0,1,3.7-.16L185,279.46c.95.55.83,1.51-.27,2.14L173.58,288A4.13,4.13,0,0,1,169.87,288.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M399.37,403.29l-11.64-6.72a3.8,3.8,0,0,0-3.46,0l-11.74,6.78c-1,.55-1,1.44,0,2l.93.54c.88.5.87,1.33,0,1.84L361,414.89c-1,.56-1,1.45,0,2l7.41,4.28a3.81,3.81,0,0,0,3.45,0l11.62-6.7,2.4-1.39,1.73-1,1.74-1,10-5.77C400.32,404.73,400.32,403.84,399.37,403.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M114.06,311.3l-11.64-6.72c-1-.55-.83-1.51.26-2.14L113.8,296a4.11,4.11,0,0,1,3.7-.15l11.65,6.72c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,114.06,311.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M130.5,320.79l-11.64-6.72c-1-.55-.83-1.51.26-2.14l11.12-6.42a4.11,4.11,0,0,1,3.7-.15l11.65,6.72c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,130.5,320.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M146.94,330.28l-11.64-6.72c-1-.55-.84-1.51.26-2.14L146.67,315a4.13,4.13,0,0,1,3.71-.15L162,321.57c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,146.94,330.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M286.94,411.11l-11.65-6.73c-1-.54-.83-1.5.27-2.14l11.11-6.41a4.13,4.13,0,0,1,3.71-.16L302,402.4c1,.55.83,1.5-.27,2.14L290.64,411A4.08,4.08,0,0,1,286.94,411.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M303.37,420.6l-11.64-6.72c-1-.55-.83-1.51.26-2.14l11.12-6.42a4.11,4.11,0,0,1,3.7-.15l11.65,6.72c1,.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,303.37,420.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M319.81,430.09l-11.64-6.72c-.95-.55-.83-1.51.26-2.14l11.12-6.42a4.11,4.11,0,0,1,3.7-.15l11.65,6.72c1,.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,319.81,430.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M336.25,439.58l-11.64-6.72c-.95-.55-.83-1.51.26-2.14L336,424.3a4.11,4.11,0,0,1,3.7-.15l11.65,6.72c1,.55.83,1.51-.27,2.14L340,439.43A4.13,4.13,0,0,1,336.25,439.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M167.61,342.22l-15.88-9.17c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l15.88,9.17c1,.55.83,1.5-.27,2.14l-11.11,6.41A4.1,4.1,0,0,1,167.61,342.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M270.5,401.62l-15.88-9.17c-1-.55-.83-1.51.26-2.14L266,383.89a4.11,4.11,0,0,1,3.7-.15l15.88,9.17c.95.55.83,1.5-.26,2.14l-11.12,6.41A4.08,4.08,0,0,1,270.5,401.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M249.82,389.68,172.41,345c-.95-.55-.83-1.51.26-2.14l11.12-6.42a4.11,4.11,0,0,1,3.7-.15L264.91,381c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,249.82,389.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M174.89,309.52l-11.64-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.11,4.11,0,0,1,3.7-.15L190,300.81c1,.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,174.89,309.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M191.36,319l-11.64-6.73c-.95-.55-.83-1.5.26-2.14l11.12-6.41a4.11,4.11,0,0,1,3.7-.16l11.65,6.73c1,.55.83,1.5-.27,2.14l-11.11,6.41A4.1,4.1,0,0,1,191.36,319Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M207.83,328.53l-11.65-6.72c-1-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c1,.55.84,1.51-.26,2.14l-11.11,6.42A4.13,4.13,0,0,1,207.83,328.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M224.3,338l-11.65-6.72c-1-.55-.83-1.51.27-2.14L224,322.76a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c1,.55.83,1.51-.26,2.14L228,337.89A4.11,4.11,0,0,1,224.3,338Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M240.76,347.55l-11.64-6.72c-1-.55-.83-1.51.26-2.14l11.12-6.42a4.11,4.11,0,0,1,3.7-.15l11.65,6.72c1,.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,240.76,347.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M257.23,357.06l-11.64-6.73c-1-.55-.84-1.5.26-2.14L257,341.78a4.1,4.1,0,0,1,3.71-.16l11.65,6.73c.95.55.83,1.5-.27,2.14l-11.11,6.41A4.1,4.1,0,0,1,257.23,357.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M273.7,366.56l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c1,.55.83,1.51-.26,2.14l-11.12,6.42A4.11,4.11,0,0,1,273.7,366.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M290.17,376.07l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.11,4.11,0,0,1,290.17,376.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M306.63,385.58,295,378.86c-.95-.55-.83-1.51.26-2.14l11.12-6.42a4.11,4.11,0,0,1,3.7-.15l11.65,6.72c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,306.63,385.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M323.1,395.09l-11.65-6.73c-.95-.55-.83-1.5.27-2.14l11.11-6.41a4.1,4.1,0,0,1,3.71-.16l11.65,6.73c.95.54.83,1.5-.27,2.14l-11.11,6.41A4.13,4.13,0,0,1,323.1,395.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M339.57,404.59l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c1,.55.83,1.51-.26,2.14l-11.12,6.42A4.11,4.11,0,0,1,339.57,404.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M356,414.1l-11.64-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.11,4.11,0,0,1,3.7-.15l11.65,6.72c.95.55.83,1.51-.27,2.14L359.74,414A4.13,4.13,0,0,1,356,414.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M158.43,300l-24.09-13.9c-1-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l24.08,13.9c1,.55.83,1.51-.26,2.14l-11.12,6.42A4.11,4.11,0,0,1,158.43,300Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.74,314,139.1,307.3c-.95-.55-.84-1.5.26-2.14l11.11-6.41a4.1,4.1,0,0,1,3.71-.16l11.65,6.73c.95.54.83,1.5-.27,2.14l-11.11,6.41A4.13,4.13,0,0,1,150.74,314Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M167.21,323.53l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c1,.55.83,1.51-.26,2.14l-11.12,6.42A4.11,4.11,0,0,1,167.21,323.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M183.67,333,172,326.31c-1-.55-.83-1.5.27-2.14l11.11-6.41a4.13,4.13,0,0,1,3.71-.16l11.65,6.73c1,.55.83,1.5-.27,2.14l-11.11,6.41A4.1,4.1,0,0,1,183.67,333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M200.13,342.54l-11.64-6.72c-1-.55-.83-1.51.27-2.14l11.11-6.42a4.11,4.11,0,0,1,3.7-.15l11.65,6.72c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,200.13,342.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M216.6,352.05,205,345.33c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c.95.55.84,1.51-.26,2.14l-11.11,6.41A4.1,4.1,0,0,1,216.6,352.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M233.06,361.55l-11.64-6.72c-.95-.55-.83-1.51.26-2.14l11.12-6.42a4.11,4.11,0,0,1,3.7-.15l11.65,6.72c.95.55.83,1.51-.27,2.14l-11.11,6.42A4.13,4.13,0,0,1,233.06,361.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M249.53,371.06l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c.95.55.83,1.51-.26,2.14l-11.11,6.42A4.13,4.13,0,0,1,249.53,371.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M266,380.57l-11.64-6.73c-.95-.55-.83-1.5.26-2.14l11.12-6.41a4.08,4.08,0,0,1,3.7-.16l11.65,6.73c.95.54.83,1.5-.27,2.14l-11.11,6.41A4.13,4.13,0,0,1,266,380.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M282.46,390.07l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c.95.55.83,1.51-.26,2.14l-11.12,6.42A4.11,4.11,0,0,1,282.46,390.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M298.92,399.58l-11.64-6.73c-.95-.54-.83-1.5.26-2.14l11.12-6.41a4.11,4.11,0,0,1,3.7-.16L314,390.87c.95.55.83,1.5-.27,2.14l-11.11,6.41A4.1,4.1,0,0,1,298.92,399.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M315.39,409.08l-11.65-6.72c-.95-.55-.83-1.51.27-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l11.64,6.72c.95.55.83,1.51-.26,2.14l-11.12,6.42A4.11,4.11,0,0,1,315.39,409.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M352.23,430.36l-32-18.49c-.95-.55-.84-1.51.26-2.14l11.11-6.42a4.13,4.13,0,0,1,3.71-.15l32,18.49c.95.54.83,1.5-.27,2.14l-11.11,6.41A4.13,4.13,0,0,1,352.23,430.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M134.28,304.52l-15.88-9.17c-1-.55-.83-1.51.26-2.14l11.12-6.41a4.08,4.08,0,0,1,3.7-.16l15.88,9.17c.95.55.83,1.51-.26,2.14L138,304.37A4.11,4.11,0,0,1,134.28,304.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M416.71,393.13l-233.84-135c-1-.54-.83-1.5.27-2.14l5.56-3.2a4.11,4.11,0,0,1,3.7-.16l233.84,135c.95.55.83,1.5-.27,2.14L420.42,393A4.13,4.13,0,0,1,416.71,393.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.85,408.48a3.53,3.53,0,0,1-1.62,1.68l-64.34,37.15a7.93,7.93,0,0,1-7.13.29l-110-63.49A2.46,2.46,0,0,1,87.68,383c-.4-1,.16-2.11,1.62-2.95l64.35-37.16a7.93,7.93,0,0,1,7.13-.29l110,63.49A1.94,1.94,0,0,1,271.85,408.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M271.85,408.48a3.53,3.53,0,0,1-1.62,1.68l-64.34,37.15a7.93,7.93,0,0,1-7.13.29l-110-63.49A2.46,2.46,0,0,1,87.68,383a3.61,3.61,0,0,1,1.62-1.67l64.35-37.15a7.94,7.94,0,0,1,7.13-.3l110,63.5A2.41,2.41,0,0,1,271.85,408.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M434.51,382.89l-233.84-135A4.12,4.12,0,0,1,199,244.6v-2.75c0-1.27.77-1.85,1.72-1.3l233.84,135a4.1,4.1,0,0,1,1.72,3.28v2.75C436.23,382.86,435.46,383.44,434.51,382.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M236,234.56,212.9,221.25c-2.89-1.67-5.24-6.16-5.24-10V186.48c0-3.86,2.35-5.63,5.24-4L236,195.83c2.9,1.67,5.24,6.16,5.24,10V230.6C241.2,234.46,238.86,236.23,236,234.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M235.91,177.83l-23.06-13.31c-2.89-1.67-5.24-8.5-5.24-11.84V123.76c0-3.86,2.35-5.63,5.24-4l23.06,13.31c2.9,1.67,5.24,6.16,5.24,10v28.92C241.15,175.39,238.81,179.5,235.91,177.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M224.51,158.51c-4.69-2.71-8.51-9.33-8.51-14.75s3.82-7.63,8.51-4.92,8.52,9.33,8.52,14.75S229.21,161.22,224.51,158.51Zm0-17.15c-3.49-2-6.33-.37-6.33,3.66a14,14,0,0,0,6.33,11c3.5,2,6.34.38,6.34-3.65A14,14,0,0,0,224.51,141.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "226.85 154.5 222.99 148.36 222.99 143.25 225.17 144.51 225.17 148.48 228.29 153.43 226.85 154.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M235.88,116.66l-23.06-13.31c-2.89-1.68-5.24-9.2-5.24-12.55V64.18c0-3.34,2.35-4.7,5.24-3l23.06,13.32a11.56,11.56,0,0,1,5.24,9.07v26.63C241.12,113.51,238.78,118.33,235.88,116.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M224.35,84.75c-1.39-.8-2.51-.15-2.51,1.46a5.54,5.54,0,0,0,2.51,4.35c1.39.8,2.52.15,2.52-1.45A5.59,5.59,0,0,0,224.35,84.75Zm6.71,1-2-1.16a1.64,1.64,0,0,1-.66-.93l-.52-2.11a1.7,1.7,0,0,0-.67-.93l-5.7-3.29c-.28-.16-.57-.09-.66.17l-.52,1.5a.43.43,0,0,1-.66.17l-2-1.16c-.92-.54-1.67-.1-1.67,1v8.72a3.71,3.71,0,0,0,1.67,2.9l13.42,7.75c.92.53,1.68.1,1.68-1V88.63A3.73,3.73,0,0,0,231.06,85.72Zm-6.71,6.78a9.29,9.29,0,0,1-4.19-7.26c0-2.68,1.88-3.76,4.19-2.42a9.24,9.24,0,0,1,4.19,7.26C228.54,92.75,226.67,93.84,224.35,92.5Zm6.12-3.83a1.28,1.28,0,0,1-.58-1c0-.38.26-.53.58-.34a1.28,1.28,0,0,1,.59,1C231.06,88.71,230.8,88.86,230.47,88.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M231.63,210.35c0,4.51-7.07,10.37-7.07,10.37s-7.08-14-7.08-18.54,3.17-6.34,7.08-4.09A15.65,15.65,0,0,1,231.63,210.35Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 224.56,
    cy: 205.95,
    rx: 3.78,
    ry: 6.54,
    transform: "translate(-72.89 139.88) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M399.13,271,259.52,190.39c-2.36-1.35-4.26-5-4.26-8.13V88.43c0-3.13,1.9-4.57,4.26-3.21l139.61,80.6c2.35,1.36,4.25,5,4.25,8.14v93.82C403.38,270.92,401.48,272.36,399.13,271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M383,202.79,274.79,140.32c-2.62-1.52-4.75-5.58-4.75-9.07v-7.07c0-3.5,2.13-5.1,4.75-3.59L383,183.06c2.62,1.51,4.74,5.57,4.74,9.07v7.07C387.74,202.7,385.62,204.3,383,202.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M324.15,200.6l-49.36-28.5c-2.62-1.51-4.75-5.57-4.75-9.07V156c0-3.5,2.13-5.1,4.75-3.59l49.36,28.5c2.62,1.51,4.74,5.57,4.74,9.07V197C328.89,200.5,326.77,202.11,324.15,200.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M427.86,291.64s-52.63,11.6-95.18-35.66-77.26-41.2-77.26-41.2v29.5l172.44,99.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M427.86,291.64s-52.63,11.6-95.18-35.66-77.26-41.2-77.26-41.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Men_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-13",
    d: "M255.19,44.4A38.54,38.54,0,0,1,249.62,52c-.6.7-5.23-1.07-4.26-1.57s4-4.72,5.52-7.54a96.19,96.19,0,0,0,3.24-10.29c.95-3.45,1.77-8.51,2.47-10.89a4.65,4.65,0,0,1,3.54-3.61c1.67-.39,2.75.07,2.44,2.09C262,23.71,259.27,37.45,255.19,44.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M257.84,98.25c-1.43,1.17-3.55.1-3.66.21a65.73,65.73,0,0,1-5.29,4.41c-.9.7-2.29,1.64-2,3,.45,2.41,4.32,1.67,5.78.93s2.66-2,4-2.82c1-.62,2-.93,2.11-2.18C258.87,101.05,258.1,98.22,257.84,98.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M258.76,101.3c-.19,1.19-1.15,1.52-2.13,2.13-1.4.87-2.64,2.13-4.1,2.87s-4.71,1.36-5.66-.37c.51,2.33,4.32,1.6,5.76.87s2.66-2,4-2.82c1-.62,2-.93,2.11-2.18A3.08,3.08,0,0,0,258.76,101.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M243.28,89.86c-1.43,1.17-3.94-.1-4.05,0a53,53,0,0,1-4.73,4.27c-.9.71-2.29,1.65-2,3,.45,2.42,4.32,1.68,5.79.94s2.65-2,4-2.83c1-.61,2-.93,2.11-2.17C244.48,92.32,243.54,89.83,243.28,89.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M244.35,92.74c-.19,1.19-1.15,1.52-2.13,2.13-1.4.87-2.64,2.13-4.1,2.87s-4.72,1.36-5.66-.37c.51,2.33,4.31,1.6,5.76.87s2.65-2,4-2.83c1-.61,2-.92,2.11-2.17A3.08,3.08,0,0,0,244.35,92.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-10",
    d: "M277,52.24c1.59,9.94-2.82,13.65-8.56,15.76-4.12,1.52-10,3.86-10,3.86s.08,2.18.12,7.07c0,4.31-.52,20-.52,20a4.81,4.81,0,0,1-4.4,0s-2.31-12.05-2.8-17.49c-.67-7.37-1.8-12.2-1.42-13.79.33-1.4,8.39-5.36,10.95-7.48l-16.89,5.66a29.83,29.83,0,0,1,.49,5.55c-.15,5.85-.48,18.52-.48,18.52s-2.31,1.67-4.29,0c0,0-4.25-25.07-3.73-28.39.49-3.15,15.37-9.59,18-11.81a4.2,4.2,0,0,1,3.3-.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_2",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-16",
    d: "M236.54,56.38l11.35-6.55a.63.63,0,0,1,.65,0l19.9,11.49-11.67,6.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M257.3,65.65l.87.5c.07,0,.06.11,0,.16l-.83.48a.32.32,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.48A.32.32,0,0,1,257.3,65.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M256.08,65l.86.49c.07,0,.06.12,0,.16l-.82.48a.31.31,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16l.82-.47A.28.28,0,0,1,256.08,65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M254.84,64.23l.86.5c.07,0,.07.11,0,.16l-.82.47a.31.31,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16l.82-.48A.31.31,0,0,1,254.84,64.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M253.63,63.53l.86.5c.07,0,.07.11,0,.16l-.82.48a.34.34,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16l.82-.48A.34.34,0,0,1,253.63,63.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M252.4,62.82l.87.5c.07,0,.06.12,0,.16l-.83.48a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.29.29,0,0,1,252.4,62.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M251.18,62.12l.87.5c.07,0,.06.11,0,.16l-.83.47a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.15l.83-.48A.29.29,0,0,1,251.18,62.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M250,61.41l.86.5c.07,0,.06.11,0,.16l-.82.48a.34.34,0,0,1-.28,0l-.86-.5c-.07,0-.07-.11,0-.16l.82-.48A.34.34,0,0,1,250,61.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M248.73,60.7l.87.5c.07,0,.06.12,0,.16l-.83.48a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.29.29,0,0,1,248.73,60.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M247.51,60l.86.5c.07,0,.06.11,0,.16l-.82.47a.31.31,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.15l.82-.48A.31.31,0,0,1,247.51,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M246.28,59.29l.87.5c.07,0,.06.11,0,.16l-.83.48a.32.32,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.48A.29.29,0,0,1,246.28,59.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M245.06,58.58l.86.5c.07,0,.07.11,0,.16l-.82.48a.31.31,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16l.82-.47A.31.31,0,0,1,245.06,58.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M243.84,57.88l.86.5c.07,0,.06.11,0,.16l-.83.47a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.31.31,0,0,1,243.84,57.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M242.61,57.17l.87.5c.07,0,.06.11,0,.16l-.83.47a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.12,0-.16l.83-.48A.29.29,0,0,1,242.61,57.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M240.8,56.12l1.45.84c.07,0,.06.11,0,.16l-.82.48a.34.34,0,0,1-.28,0l-1.45-.84c-.07,0-.07-.11,0-.16l.82-.48A.34.34,0,0,1,240.8,56.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M256.67,63.92l.87.5c.07,0,.06.11,0,.16l-.83.47a.26.26,0,0,1-.27,0l-.87-.49c-.07,0-.06-.12,0-.16l.83-.48A.29.29,0,0,1,256.67,63.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M255.45,63.21l.86.5c.07,0,.06.11,0,.16l-.82.48a.34.34,0,0,1-.28,0l-.86-.5c-.07,0-.07-.11,0-.16l.82-.48A.31.31,0,0,1,255.45,63.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M254.22,62.5l.86.5c.08,0,.07.11,0,.16l-.82.48a.34.34,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16l.82-.48A.34.34,0,0,1,254.22,62.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M253,61.79l.87.5c.07,0,.06.12,0,.16l-.83.48a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.29.29,0,0,1,253,61.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M251.78,61.09l.86.5c.07,0,.06.11,0,.16l-.82.48a.34.34,0,0,1-.28,0l-.86-.5c-.07,0-.07-.11,0-.16l.82-.48A.34.34,0,0,1,251.78,61.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M250.55,60.38l.87.5c.07,0,.06.12,0,.16l-.83.48a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.29.29,0,0,1,250.55,60.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M249.32,59.68l.87.5c.07,0,.06.11,0,.15l-.83.48a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.29.29,0,0,1,249.32,59.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M248.1,59l.86.5c.07,0,.06.11,0,.16l-.82.47a.31.31,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.15l.82-.48A.31.31,0,0,1,248.1,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M246.87,58.26l.87.5c.07,0,.06.11,0,.16l-.83.47a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.12,0-.16l.83-.48A.29.29,0,0,1,246.87,58.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M245.65,57.55l.86.5c.07,0,.06.11,0,.16l-.83.48a.32.32,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.48A.34.34,0,0,1,245.65,57.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M244.42,56.84l.86.5c.07,0,.07.11,0,.16l-.82.48a.31.31,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16l.82-.48A.34.34,0,0,1,244.42,56.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M243.19,56.14l.87.49c.07,0,.06.12,0,.16l-.83.48a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.26.26,0,0,1,243.19,56.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M257.9,64.63l1.45.84c.07,0,.07.11,0,.16l-.82.47a.31.31,0,0,1-.28,0l-1.45-.84c-.07,0-.06-.11,0-.16l.82-.47A.31.31,0,0,1,257.9,64.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M240.86,56.08l.86.5a.3.3,0,0,0,.26,0l.87-.51a.08.08,0,0,0,0-.15l-.07,0c-.06,0-.06-.09,0-.13l.92-.53c.08,0,.08-.11,0-.15l-.55-.32a.3.3,0,0,0-.26,0l-.86.5-.18.1-.13.08-.13.07-.74.43A.08.08,0,0,0,240.86,56.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M262,62.91l.87.5c.07,0,.06.11,0,.16l-.83.47a.26.26,0,0,1-.27,0l-.87-.49c-.07-.05-.06-.12,0-.16l.83-.48A.29.29,0,0,1,262,62.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M260.82,62.2l.87.5c.07,0,.06.12,0,.16l-.83.48a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.29.29,0,0,1,260.82,62.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M259.6,61.5l.87.5c.07,0,.06.11,0,.16l-.83.47a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.12,0-.16l.83-.48A.29.29,0,0,1,259.6,61.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M249.21,55.5l.86.5c.07,0,.06.11,0,.16l-.82.47a.31.31,0,0,1-.28,0l-.86-.5c-.08,0-.07-.11,0-.16l.82-.47A.31.31,0,0,1,249.21,55.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M248,54.79l.87.5c.07,0,.06.11,0,.16l-.83.48a.32.32,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.48A.32.32,0,0,1,248,54.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M246.76,54.09l.87.5c.07,0,.06.11,0,.16l-.83.47a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.15l.83-.48A.29.29,0,0,1,246.76,54.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M245.54,53.38l.87.5c.07,0,.06.11,0,.16l-.83.48a.32.32,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.48A.32.32,0,0,1,245.54,53.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M258.07,60.61l1.18.68c.07,0,.06.12,0,.16l-.83.48a.29.29,0,0,1-.27,0L257,61.26c-.07,0-.07-.11,0-.16l.82-.48A.34.34,0,0,1,258.07,60.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M250.43,56.2l1.18.68c.07,0,.06.11,0,.16l-.83.48a.32.32,0,0,1-.27,0l-1.18-.68c-.07,0-.07-.11,0-.16l.82-.48A.34.34,0,0,1,250.43,56.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M252,57.09l5.75,3.32c.07,0,.06.11,0,.16l-.82.47a.31.31,0,0,1-.28,0l-5.75-3.32c-.07,0-.06-.11,0-.15l.83-.48A.29.29,0,0,1,252,57.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M257.53,63l.86.5c.07,0,.06.11,0,.16l-.82.48a.34.34,0,0,1-.28,0l-.86-.5c-.07,0-.07-.11,0-.16l.82-.48A.34.34,0,0,1,257.53,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M256.3,62.33l.87.5c.07,0,.06.12,0,.16l-.83.48a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.29.29,0,0,1,256.3,62.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M255.08,61.63l.87.5c.07,0,.06.11,0,.16l-.83.47a.31.31,0,0,1-.28,0l-.86-.5c-.07-.05-.06-.12,0-.16l.83-.48A.29.29,0,0,1,255.08,61.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M253.86,60.92l.86.5c.07,0,.06.11,0,.16l-.82.48a.34.34,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16l.82-.48A.34.34,0,0,1,253.86,60.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M252.63,60.22l.87.5c.07,0,.06.11,0,.16l-.83.47a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.29.29,0,0,1,252.63,60.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M251.41,59.51l.87.5c.07,0,.06.11,0,.16l-.83.48a.32.32,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.48A.32.32,0,0,1,251.41,59.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M250.19,58.8l.86.5c.07,0,.07.12,0,.16l-.82.48a.31.31,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16l.82-.47A.31.31,0,0,1,250.19,58.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M249,58.1l.86.5c.07,0,.06.11,0,.16l-.82.47a.28.28,0,0,1-.28,0l-.86-.49c-.07,0-.07-.12,0-.16l.82-.48A.31.31,0,0,1,249,58.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M247.74,57.39l.87.5c.07,0,.06.11,0,.16l-.83.48a.32.32,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.48A.32.32,0,0,1,247.74,57.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M246.52,56.69l.86.5c.08,0,.07.11,0,.15l-.83.48a.31.31,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16l.82-.47A.31.31,0,0,1,246.52,56.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M245.3,56l.86.5c.07,0,.06.11,0,.16l-.82.48a.34.34,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16L245,56A.31.31,0,0,1,245.3,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M244.07,55.27l.87.5c.07,0,.06.12,0,.16l-.83.48a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.29.29,0,0,1,244.07,55.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M258.75,63.75l1.79,1c.07,0,.06.11,0,.16l-.83.48a.32.32,0,0,1-.27,0l-1.79-1c-.07,0-.06-.11,0-.16l.82-.47A.31.31,0,0,1,258.75,63.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M259.32,62.71l.86.5c.08,0,.07.11,0,.15l-.82.48a.31.31,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16l.82-.47A.31.31,0,0,1,259.32,62.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M258.1,62l.86.5c.07,0,.06.11,0,.16l-.82.48a.34.34,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16l.82-.48A.31.31,0,0,1,258.1,62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M256.87,61.29l.87.5c.07,0,.06.12,0,.16l-.83.48a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.29.29,0,0,1,256.87,61.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M255.65,60.59l.87.5c.07,0,.06.11,0,.16l-.83.47a.26.26,0,0,1-.27,0l-.87-.49c-.07-.05-.06-.12,0-.16l.83-.48A.29.29,0,0,1,255.65,60.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M254.43,59.88l.86.5c.07,0,.07.11,0,.16l-.82.48a.34.34,0,0,1-.28,0l-.86-.5c-.07,0-.06-.11,0-.16l.82-.48A.34.34,0,0,1,254.43,59.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M253.21,59.18l.86.5c.07,0,.06.11,0,.15l-.82.48a.31.31,0,0,1-.28,0l-.86-.5c-.07,0-.07-.11,0-.16l.82-.47A.31.31,0,0,1,253.21,59.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M252,58.47l.87.5c.07,0,.06.11,0,.16l-.83.48a.32.32,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.48A.32.32,0,0,1,252,58.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M250.76,57.76l.87.5c.07,0,.06.12,0,.16l-.83.48a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.16l.83-.47A.29.29,0,0,1,250.76,57.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M249.54,57.06l.86.5c.07,0,.06.11,0,.16l-.82.47a.31.31,0,0,1-.28,0l-.86-.5c-.07,0-.06-.12,0-.16l.82-.48A.31.31,0,0,1,249.54,57.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M248.32,56.35l.86.5c.07,0,.06.11,0,.16l-.82.48a.34.34,0,0,1-.28,0l-.86-.5c-.08,0-.07-.11,0-.16l.82-.48A.34.34,0,0,1,248.32,56.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M247.09,55.65l.87.5c.07,0,.06.11,0,.16l-.83.47a.29.29,0,0,1-.27,0l-.87-.5c-.07,0-.06-.11,0-.15l.83-.48A.29.29,0,0,1,247.09,55.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M244.36,54.07l2.38,1.37c.07,0,.06.11,0,.16l-.83.48a.34.34,0,0,1-.28,0l-2.37-1.38c-.07,0-.07-.11,0-.15l.82-.48A.31.31,0,0,1,244.36,54.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M260.54,63.41l1.18.68c.07,0,.06.12,0,.16l-.82.48a.31.31,0,0,1-.28,0l-1.18-.68c-.07,0-.06-.11,0-.16l.83-.48A.32.32,0,0,1,260.54,63.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M239.57,56.83l17.36,10c.07,0,.07.11,0,.16l-.41.23a.29.29,0,0,1-.27,0l-17.37-10c-.07,0-.06-.11,0-.16l.41-.24A.34.34,0,0,1,239.57,56.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_4",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-18",
    points: "259.89 57.28 259.77 57.34 256.77 59.08 251.44 56 251.33 55.93 254.44 54.14 259.89 57.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-19",
    points: "259.77 57.34 256.77 59.08 251.44 56 254.44 54.27 259.77 57.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-19",
    d: "M268.44,61.32v.27a1.09,1.09,0,0,1-.54.95l-10.58,6.1a1.07,1.07,0,0,1-1.09,0l-19.14-11a1.1,1.1,0,0,1-.55-1v-.27l20.23,11.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-16",
    d: "M256.47,68.22a1.3,1.3,0,0,1-1.12-.08l-19-11a1.29,1.29,0,0,1-.63-.91l-2.09-12.44a1.49,1.49,0,0,1,0-.21,1.27,1.27,0,0,1,.39-.92l19.8,11.43a1,1,0,0,1,.46.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-19",
    d: "M256.77,68.06l-.13.08-.17.08-2.26-13.46a1,1,0,0,0-.46-.67L234,42.66a.86.86,0,0,1,.26-.2l19.84,11.45a1,1,0,0,1,.47.67Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_9",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-13",
    d: "M271.16,14.83s-.25,4.73-.14,5.15,2.17,1.81,2.77,2.31-3.27,4.32-5.15,5.18-7.86-1.41-8-4.35,1-5.39,1.94-5.52S271.16,14.83,271.16,14.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_10",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-16",
    d: "M271.68,20.8s-3.43,5.12-8.22,5.6c-1.51-1.49-1.65-6.79.44-8.48,0,0-1.92-1.56-3.24-1.25a6.75,6.75,0,0,0-3,3.77,30.8,30.8,0,0,0-1.69,11c.08,5,0,17.71,0,17.71a10.81,10.81,0,0,0,5.05,7.27A15.59,15.59,0,0,0,272.43,58c2.43-.57,3.33-1.92,4.17-3.69-.22-3.51-1.61-10.76-1-15.19s1.52-7.73,1.76-11.3-.47-3.51-2.27-4.79A28.11,28.11,0,0,0,271.68,20.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-13",
    d: "M266.18,61.59a23,23,0,0,1,2.69-1.54,5.71,5.71,0,0,0,2.3-1.4c.84-.82,2.22-3.94,3.21-7a31.2,31.2,0,0,0,1.15-10.57c-.41-4.27-1.95-10.24-2.34-12.69s.4-3.44,1.55-4.34c1.34-1.06,3.19-.59,4.18,2.85a66,66,0,0,1,2.2,14.57,33.18,33.18,0,0,1-1.67,10.77,38.88,38.88,0,0,1-4.1,8.46c-.47.79-.63,1.5-1.35,3.12A10.88,10.88,0,0,1,270.86,68c-1.2.86-1.77,1-2.06.82s-.28-.59.23-1a9.08,9.08,0,0,0,2.14-2.41s-1.05,1.06-1.74,1.64a9,9,0,0,1-2,1.28c-.7.31-1.68-.29-1.18-.76s1-.71,2-1.58a8.65,8.65,0,0,0,1.43-1.55,16.71,16.71,0,0,1-2.23,1.45,3.81,3.81,0,0,1-2,.55c-.37,0-.82-.54-.12-1A13.71,13.71,0,0,0,268,63.55c.77-.76,1.2-1.41,1-1.42s-.64.46-1.54.75-1.87,0-2-.47S265.34,62,266.18,61.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-13",
    d: "M260.44,7.77h0c.57-3.67,3.22-6.45,7-6.24a7.28,7.28,0,0,1,3.71,13.3,7.45,7.45,0,0,1-.59,1.61C269.23,18,265.18,19,264,18.8a3.45,3.45,0,0,1-3-2.47C259.74,13.45,260.13,9.59,260.44,7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M271.16,14.83h0l-.35-3.21s2.62-6.78-3.57-5.48c-4.08.86-5.11,1.24-6.35-1.5S264-.57,269.23.12a7.18,7.18,0,0,1,6.44,7.29C275.54,9.43,275,13.51,271.16,14.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M281.75,33.23s-3.38,3.36-7.37,2.39c-.57-.39-1.95-8.24-1.95-8.24s0-4.35,3.34-4.24S281.75,33.23,281.75,33.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M256.25,26.71a3.67,3.67,0,0,1-2.5-1.11c.14-1.76,2.39-8.44,6.91-8.93a8.35,8.35,0,0,0-2.82,3.41A43.31,43.31,0,0,0,256.25,26.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M459.4,311.15l-83.52-48.22c-5.25-3-9.5-11.15-9.5-18.14V113.38c0-7,4.25-10.2,9.5-7.18l83.52,48.23c5.24,3,9.49,11.15,9.49,18.14V304C468.89,311,464.64,314.18,459.4,311.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "462.74 313.07 465.6 311.66 463.67 307.87 462.74 313.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M367.94,106.57a16.71,16.71,0,0,1,2.64-1.27l2.12,4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M457.21,312.25,373.68,264c-5.24-3-9.49-11.15-9.49-18.14V114.48c0-7,4.25-10.21,9.49-7.18l83.53,48.23c5.24,3,9.49,11.14,9.49,18.13V305.07C466.7,312.06,462.45,315.28,457.21,312.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 134.7 373.68 125.93 373.68 120.45 388.87 129.22 388.87 134.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "456.26 173.61 391.72 136.34 391.72 130.87 456.26 168.13 456.26 173.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 152.24 373.68 143.47 373.68 137.99 388.87 146.76 388.87 152.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "434.43 178.54 391.72 153.88 391.72 148.4 434.43 173.06 434.43 178.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 161 373.68 152.24 373.68 146.76 388.87 155.52 388.87 161"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "444.87 193.34 391.72 162.65 391.72 157.17 444.87 187.86 444.87 193.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 169.77 373.68 161 373.68 155.52 388.87 164.29 388.87 169.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "428.74 192.79 391.72 171.42 391.72 165.94 428.74 187.31 428.74 192.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 143.47 373.68 134.7 373.68 129.22 388.87 137.99 388.87 143.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "423.99 163.75 391.72 145.11 391.72 139.63 423.99 158.26 423.99 163.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 178.54 373.68 169.77 373.68 164.29 388.87 173.06 388.87 178.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "410.7 191.14 391.72 180.18 391.72 174.7 410.7 185.66 410.7 191.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 196.07 373.68 187.31 373.68 181.83 388.87 190.6 388.87 196.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "451.52 232.24 391.72 197.72 391.72 192.24 451.52 226.76 451.52 232.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 204.84 373.68 196.07 373.68 190.59 388.87 199.36 388.87 204.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "409.75 216.9 391.72 206.49 391.72 201.01 409.75 211.42 409.75 216.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 213.61 373.68 204.84 373.68 199.36 388.87 208.13 388.87 213.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "444.87 245.94 391.72 215.25 391.72 209.78 444.87 240.46 444.87 245.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 187.31 373.68 178.54 373.68 173.06 388.87 181.83 388.87 187.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "442.02 218 391.72 188.95 391.72 183.47 442.02 212.52 442.02 218"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 222.38 373.68 213.61 373.68 208.13 388.87 216.9 388.87 222.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "398.36 227.86 391.72 224.02 391.72 218.54 398.36 222.38 398.36 227.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 239.91 373.68 231.15 373.68 225.67 388.87 234.44 388.87 239.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "404.06 248.68 391.72 241.56 391.72 236.08 404.06 243.2 404.06 248.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 248.68 373.68 239.91 373.68 234.43 388.87 243.2 388.87 248.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "423.99 268.96 391.72 250.33 391.72 244.85 423.99 263.48 423.99 268.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 257.45 373.68 248.68 373.68 243.2 388.87 251.97 388.87 257.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "442.97 288.69 391.72 259.09 391.72 253.61 442.97 283.21 442.97 288.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "388.87 231.15 373.68 222.38 373.68 216.9 388.87 225.67 388.87 231.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "456.26 270.06 391.72 232.79 391.72 227.31 456.26 264.57 456.26 270.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.12,211.94,27,207.26l-19.11,11c-4.33,2.5-7.85.48-7.85-4.53V192.91a17.36,17.36,0,0,1,7.85-13.6L121.7,113.58c4.33-2.5,7.85-.47,7.85,4.53V139a17.36,17.36,0,0,1-7.85,13.6L45.18,196.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "126.7 112.77 131 114.51 127.36 118.25 124.78 114.12 126.7 112.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.12 211.94 40.65 213.76 40.66 209.86 36.65 209.06 36.12 211.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.61,221c.17.36-4.91-1.72-5.09-2S8.68,215,8.68,215Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M49.71,198.55l76.52-44.17a17.39,17.39,0,0,0,7.85-13.6V119.93c0-5-3.52-7-7.85-4.54L12.38,181.12a17.38,17.38,0,0,0-7.85,13.6v20.85c0,5,3.52,7,7.85,4.53l19.11-11,9.16,4.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "123.87 133.53 14.74 196.53 14.74 189.28 123.87 126.27 123.87 133.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "86.19 167.98 14.74 209.23 14.74 201.97 86.19 160.72 86.19 167.98"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDevelopmentSvg);
export default __webpack_public_path__ + "static/media/app_development_SVG.5374a95f7b6a5588e4c509fc8a0d8c95.svg";
export { ForwardRef as ReactComponent };